const PLATFORM = {
  meta: { label: 'M', cls: 'bg-blue-100 text-blue-800' },
  google: { label: 'G', cls: 'bg-amber-100 text-amber-800' },
};

/**
 * Chip de plataforma (M/G) + punto de estado (verde = activa/enabled).
 */
export default function PlatformBadge({ platform, status }) {
  const p = PLATFORM[platform] ?? { label: '?', cls: 'bg-gray-100 text-gray-700' };
  const active = status ? /active|enabled/i.test(status) : false;
  return (
    <span className="inline-flex items-center gap-2">
      <span
        className={`inline-flex h-5 w-5 items-center justify-center rounded-md text-xs font-semibold ${p.cls}`}
        title={platform ?? 'plataforma'}
      >
        {p.label}
      </span>
      <span
        className={`h-1.5 w-1.5 shrink-0 rounded-full ${active ? 'bg-emerald-500' : 'bg-gray-300'}`}
        title={status ?? 'sin estado'}
      />
    </span>
  );
}
